<template>
  <div class="wrapper" ref="wrapper">
    <home-nav></home-nav>
    <banner @click="resizeWindow"></banner>
    <module-news :imageList="newsPicList"></module-news>
    <module-character :list="characterList"></module-character>
    <module-feature :list="featureList"></module-feature>
    <module-community></module-community>
    <module-footer></module-footer>
    <wechat-tips-wrapper v-if="wechatTipsVisible" />
  </div>
</template>

<script>
import { getHomeData } from '@/api/system.api.js'

import HomeNav from './components/nav'
import Banner from './components/banner'
import ModuleNews from './components/news'
import ModuleCharacter from './components/character'
import ModuleFeature from './components/feature'
import ModuleCommunity from './components/community'
import ModuleFooter from '../components/footer'
import WechatTipsWrapper from './components/wechatTipsWrapper'

export default {
  components: {
    HomeNav,
    Banner,
    ModuleNews,
    ModuleCharacter,
    ModuleFeature,
    ModuleCommunity,
    ModuleFooter,
    WechatTipsWrapper,
  },
  data() {
    return {
      newsPicList: [],
      characterList: [],
      featureList: [],
    }
  },
  created() {
    this.getHomeData()
  },
  computed: {
    wechatTipsVisible() {
      return this.$store.getters.wechatTipsVisible
    },
  },
  methods: {
    resizeWindow() {
      this.$refs.wrapper.style.position = 'fixed'
      this.$refs.wrapper.style.left = 0
      this.$refs.wrapper.style.top = 0
    },
    getHomeData() {
      getHomeData()
        .then((res) => {
          if (res.picList) {
            if (res.picList.lunbo1) this.newsPicList = res.picList.lunbo1
            if (res.picList.lunbo2) this.featureList = res.picList.lunbo2
            if (res.picList.characters) {
              this.characterList = []
              for (let i in res.picList.characters) {
                this.characterList.push({
                  active: res.picList.characters[i]['small'],
                  inactive: res.picList.characters[i]['small2'],
                  video: res.picList.characters[i]['video'],
                })
              }
            }
          }
        })
    }
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  overflow: hidden;
  max-width: 1920px;
  min-width: 1600px;
  width: 100%;
  background: #fff;
}
</style>

<style lang="scss">
.module {
  position: relative;
  margin: 0 auto;
  width: 1600px;
  height: 100%;

  > .title {
    width: 1600px;
    height: 155px;
    background-image: url('~@/assets/img/title.png');
    background-repeat: no-repeat;
  }
}
</style>
